import type { SamiJourneyPayload } from "../utils/conciergeJourney";

const STORAGE_PREFIX = "sami:active-journey";

export interface StoredJourneyMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  timestamp: string;
}

export interface StoredActiveJourney {
  userIntent: string;
  messages: StoredJourneyMessage[];
  journey: SamiJourneyPayload | null;
  currentStepIndex: number;
  completedStepIds: string[];
  updatedAt: number;
}

function storageKey(tenantId: string): string {
  return `${STORAGE_PREFIX}:${tenantId}`;
}

export function getActiveJourney(
  tenantId: string | null | undefined,
): StoredActiveJourney | null {
  if (!tenantId) return null;
  try {
    const raw = sessionStorage.getItem(storageKey(tenantId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredActiveJourney;
    if (!parsed?.messages?.length && !parsed?.journey?.steps?.length) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveActiveJourney(
  tenantId: string | null | undefined,
  journey: StoredActiveJourney,
): void {
  if (!tenantId) return;
  sessionStorage.setItem(
    storageKey(tenantId),
    JSON.stringify({ ...journey, updatedAt: Date.now() }),
  );
}

export function updateJourneyProgress(
  tenantId: string | null | undefined,
  currentStepIndex: number,
  completedStepIds: string[],
): void {
  const existing = getActiveJourney(tenantId);
  if (!existing?.journey?.steps?.length || !tenantId) return;
  saveActiveJourney(tenantId, {
    ...existing,
    currentStepIndex,
    completedStepIds,
  });
}

export function clearActiveJourney(tenantId: string | null | undefined): void {
  if (!tenantId) return;
  sessionStorage.removeItem(storageKey(tenantId));
}
